import Vue from 'vue';
import Vuex from "vuex";
import accounts from "./modules/accounts";
import app from "./modules/app";
import auth from "./modules/auth";
import trans from "./modules/trans";
import blob from "./modules/blob";
import plugins from "./plugins";

// Vue.use(Vuex);

// const store = new Vuex.Store({
// 		modules: {
// 			accounts,
// 			app,
// 			auth,
// 			trans,
// 		},
// 		plugins: plugins,
// 	});

// export default store;

Vue.use(Vuex);
export default new Vuex.Store({
	modules: {
		accounts,
		app,
		auth,
		trans,
		blob
	},
	plugins: plugins,
});